<template>
    <div>
        <h3>{{resource.subtitle}}</h3>

        <div class='container'>
            <div class='row'>
                <div class='col-sm-8'>
                    <img class='resourceImage' v-if='!resource.url && !resource.url2 && ! resource.soundcloudurl' :src='resource.image.url' >
                </div>
            </div>
        </div>
        
        <iframe class='youtubeViewer' v-if='resource.url' :src="'https://www.youtube-nocookie.com/embed/' + videoId + '?cc_load_policy=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <iframe class='youtubeViewer' v-if='resource.url2' :src="'https://www.youtube-nocookie.com/embed/' + videoId2 + '?cc_load_policy=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <iframe  v-if='resource.soundcloudurl' width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" :src="'https://w.soundcloud.com/player/?url=' + resource.soundcloudurl +  '&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true'"></iframe>

        <div class='container'>
            <div class='row resourceContent'>
                <div class='col-sm-8' v-html='resource.content'>
                    
                </div>
            </div>
        </div>

        <div>
            <image-gallery :gallery='resource.gallery' v-if='resource.gallery.length > 0'>

            </image-gallery>
        </div>
    </div>
</template>

<style>
.resourceContent {
    margin-top: 2em;
    margin-bottom: 2em;
}

img.resourceImage {
    max-width: 100%; 
}
</style>

<script>
import ImageGallery from '../components/ImageGallery'
import util from '../util'

export default {
    name: 'content-viewer',
    props: ['resource'],
    components: {
        'image-gallery': ImageGallery
    },
    computed: {
        videoId() {
            return util.videoId(this.resource.url);
        },
        videoId2() {
            return util.videoId(this.resource.url2);
        }
    },  
}
</script>